(($) => {
  let api;

  // $(() => {
  //   $('nav.breadcrumbs-container').insertBefore($('#product-builder'))
  // })

  function categoryHasMetafield(category, key) {
    const fields = category?.metafields;
    if (!Array.isArray(fields)) return false;
    return fields.some((m) => m?.key === key);
  }

  function categoryHasGroupSku(category) {
    return categoryHasMetafield(category, "bundle-source");
  }

  function categoryHasShuffGrips(category) {
    return categoryHasMetafield(category, "bundle-multiplier");
  }

  function normalizeVariantKey(value) {
    if (value == null) return null;
    const str = String(value);
    const gidMatch = str.match(/(\d+)$/);
    return gidMatch ? gidMatch[1] : str;
  }

  function buildVariantToCategoryMap(state) {
    const map = new Map();

    for (const panel of state?.Product?.panels ?? []) {
      const panelId = String(panel?.id ?? "");

      for (const category of panel?.categories ?? []) {
        const categoryId = String(category?.id ?? "");
        const categoryMeta = {
          categoryId,
          categoryTitle: category?.title ?? category?.name,
          panelId,
          groupSku: categoryHasGroupSku(category),
          shuffGrips: categoryHasShuffGrips(category),
        };

        for (const option of category?.options ?? []) {
          const variantId =
            option?.inventory?.variant ??
            option?.inventory?.id ??
            option?.variant ??
            null;

          const normalizedKey = normalizeVariantKey(variantId);
          if (!normalizedKey) continue;

          const existing = map.get(normalizedKey);
          if (!existing) {
            map.set(normalizedKey, categoryMeta);
            continue;
          }

          existing.groupSku = existing.groupSku || categoryMeta.groupSku;
          existing.shuffGrips = existing.shuffGrips || categoryMeta.shuffGrips;

          if (!existing.categoryId && categoryMeta.categoryId) {
            existing.categoryId = categoryMeta.categoryId;
          }
        }
      }
    }

    return map;
  }

  function flushGrouped(out, grouped) {
    if (grouped.size === 0) return;
    for (const line of grouped.values()) out.push(line);
    grouped.clear();
  }

  function mergeCpbLinesByCategory(cartItems, variantToCategory) {
    const out = [];
    const grouped = new Map();
    const shuffGripLines = [];
    let totalGroupSkuQuantity = 0;

    const getItemQuantity = (item) => {
      const qty = Number(item?.quantity);
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    };

    for (const item of cartItems ?? []) {
      if (!item?.properties?._cpb_frs_id) {
        flushGrouped(out, grouped);
        out.push(item);
        continue;
      }

      const itemVariantKey = normalizeVariantKey(item?.id ?? item?.variant_id);
      const meta = itemVariantKey
        ? variantToCategory.get(itemVariantKey)
        : null;
      if (!meta?.groupSku) {
        if (meta?.shuffGrips) shuffGripLines.push(item);
        flushGrouped(out, grouped);
        out.push(item);
        continue;
      }

      const bucketKey = meta?.categoryId
        ? `cat:${meta.categoryId}`
        : "cat:unknown";

      if (!grouped.has(bucketKey)) {
        item.quantity = getItemQuantity(item);
        totalGroupSkuQuantity += item.quantity;
        grouped.set(bucketKey, item);
        continue;
      }

      const merged = grouped.get(bucketKey);
      const currentQty = getItemQuantity(item);
      totalGroupSkuQuantity += currentQty;
      merged.quantity = getItemQuantity(merged) + currentQty;
    }

    flushGrouped(out, grouped);

    if (totalGroupSkuQuantity > 0) {
      for (const shuffGripLine of shuffGripLines) {
        shuffGripLine.quantity = totalGroupSkuQuantity;
      }
    }

    return out;
  }

  function getProductDetails() {
    const product = CPB.getStore().getState().Product;
    let details = { panels: [] };
    product.panels.forEach((panel) => {
      let panelOjb = {
        title: panel.title,
        categories: [],
      };
      const panelLayers = product.layers.filter(
        (layer) => layer.panel === panel.id
      );
      if (panelLayers.length === 0) return;
      panel.categories.forEach((category) => {
        let categoryObj = {
          title: category.title,
          options: [],
          categoryObj: category,
        };
        const categoryLayers = panelLayers.filter(
          (layer) => layer.category === category.id
        );
        if (categoryLayers.length === 0) return;
        category.options.forEach((option) => {
          const optionLayer = categoryLayers.find(
            (layer) => layer.option === option.id
          );
          if (!optionLayer) return;
          const value =
            category.type === "input" || category.type === "inputLong"
              ? optionLayer.value
              : option.option.data.label;
          categoryObj.options.push({
            value,
            sku: option.sku,
            optionObj: option,
          });
        });
        if (categoryObj.options.length) panelOjb.categories.push(categoryObj);
      });
      if (panelOjb.categories.length) details.panels.push(panelOjb);
    });
    return details;
  }

  function isProductComplete() {
    const categoryTypesToIgnore = ["calculateFields"];
    const product = CPB.getStore().getState().Product;
    let requiredNotSelectedCategories = [];
    product.panels.forEach((panel) => {
      if (api.checkLogic(panel) === false) return;
      requiredNotSelectedCategories = requiredNotSelectedCategories.concat(
        panel.categories.filter((category) => {
          if (
            category.required &&
            !product.layers.find((layer) => layer.category === category.id) &&
            api.checkLogic(category)
          ) {
            if (categoryTypesToIgnore.includes(category.type)) return;
            requiredNotSelectedCategories.push(category);
          }
        })
      );
    });
    return !requiredNotSelectedCategories.length;
  }

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      var separator = uri.indexOf("?") !== -1 ? "&" : "?";
      return uri + separator + key + "=" + value + hash;
    }
  }

  var getProductConfigUrl = async function () {
    var configId = await window._cpb.saveConfig(null, false);
    return updateQueryStringParameter(
      window.location.href,
      "configid",
      configId
    );
  };

  function addToQuoteInit() {
    const addToCartBtn = $(".cpb-add-to-cart-button");
    const samitaButton = document.querySelector(
      ".btn.button.rfq-btn.rfq-btn-838"
    );
    const productForm = $("form[data-product-form]");
    productForm.append(samitaButton);
    const addToQuoteBtn = productForm.find(
      'button[onclick*="GRFQApp.addProduct"]'
    );
    if (addToQuoteBtn.length === 0) return;

    addToCartBtn.css({
      display: "none",
      visibility: "hidden",
      pointerEvents: "none",
    });

    const customAddToCartButton = $(
      '<button class="cpb-custom-add-to-cart btn">'
    ).text("Add to Quote");

    $("#product-builder").attr("data-cpb-custom-add-to-quote", true);

    customAddToCartButton.on("click", async () => {
      if (!isProductComplete()) {
        addToCartBtn.trigger("click");
        return;
      }
      customAddToCartButton.attr("disabled", true);
      await addProductDetails();
      addToQuoteBtn.trigger("click");
      // setTimeout(() => {s
      //   debugger
      // }, 50)
    });

    addToCartBtn.after(customAddToCartButton);

    async function addProductDetails() {
      productForm.find(".cpb-custom-product-details-wrapper").remove();

      const wrapper = $('<div class="cpb-custom-product-details-wrapper">');
      const productDetails = getProductDetails();

      productForm.append(wrapper);

      productDetails.panels.forEach((panel) => {
        panel.categories.forEach((category) => {
          const propertyName = panel.title + " - " + category.title;

          let propertyValue = "";

          category.options.forEach((option, i) => {
            if (i > 0) propertyValue += ", ";

            propertyValue += option.value || "";

            if (option.sku) {
              propertyValue += ` [${option.sku}]`;
            }
          });

          const input = $("<input>", {
            type: "hidden",
            name: `properties[${propertyName}]`,
            value: propertyValue,
          });

          wrapper.append(input);
        });
      });

      const url = await getProductConfigUrl();

      wrapper.append(
        $("<input>", {
          type: "hidden",
          name: "properties[Configuration]",
          value: `${url}&p${CPB.getStore().getState().Product.price}`,
        })
      );

      wrapper.append(
        $("<input>", {
          type: "hidden",
          name: "properties[end]",
          value: "1",
        })
      );

      return true;
    }
  }

  function customAddToCart() {
    if (!window._cpb.settings) window._cpb.settings = {};
    window._cpb.settings.addToCartOverride = async (data) => {
      const items = data.items ?? [];

      if (items.length >= 2) {
        let sourceQty;
        const targetIds = [];
        const productDetails = getProductDetails();
        let propKeeperItemId;

        const randomString = (i) => {
          let rnd = "";
          while (rnd.length < i) rnd += Math.random().toString(36).substring(2);
          return rnd.substring(0, i);
        };

        const bundleId = randomString(10);

        productDetails.panels.forEach((p) =>
          p.categories.forEach((c) => {
            const mult =
              c.categoryObj.metafields &&
              c.categoryObj.metafields.find(
                (mf) => mf.key == "custom-multiplier"
              );
            if (!mult) return;
            const value = mult.value;
            if (value.includes("source-option")) {
              sourceQty = c.options.length;
            }
            if (value.includes("target-option")) {
              c.options.forEach((o) => {
                if (o.optionObj.inventory) {
                  targetIds.push(o.optionObj.inventory.variant.toString());
                }
              });
            }
            if (value.includes("prop-keeper")) {
              c.options.forEach((o) => {
                if (o.optionObj.inventory) {
                  propKeeperItemId = o.optionObj.inventory.variant.toString();
                }
              });
            }
          })
        );

        items.forEach((item, i, arr) => {
          if (!item.properties) item.properties = {};
          item.properties._bundleId = bundleId;

          if (sourceQty && targetIds.includes(item.id.toString())) {
            item.quantity = sourceQty;
          }
          if (item.id.toString() == propKeeperItemId) {
            const cfg = items.find((currItem) => currItem.configid);
            if (cfg && cfg.properties) {
              item.properties = Object.assign(item.properties, cfg.properties);
            }
          }
          if (propKeeperItemId && item.configid) {
            item.quantity = 0;
          }
        });

        const mainItem =
          items.find((item) => item.id?.toString() == propKeeperItemId) ??
          items.find((item) => item.configid) ??
          items[0];

        if (mainItem) {
          if (!mainItem.properties) mainItem.properties = {};
        }

        let nextBundleIndex = 1;
        items.forEach((item) => {
          if (!item.properties) item.properties = {};
          if (item === mainItem) {
            item.properties._bundleIndex = 0;
            return;
          }
          item.properties._bundleIndex = nextBundleIndex++;
        });
      }

      const variantToCategory = buildVariantToCategoryMap(
        CPB.getStore().getState()
      );
      const finalItems = mergeCpbLinesByCategory(items, variantToCategory);
      const orderedItems = [...finalItems].reverse();

      await fetch("/cart/add.js", {
        headers: { "content-type": "application/json;charset=UTF-8" },
        body: JSON.stringify({ items: orderedItems }),
        method: "POST",
      });

      if (data.redirect) location.href = "/cart";
    };
  }

  const LAYERS_PRICE_SUM_CLASS = "cpb-layers-price-sum";

  function parseLayerPrice(price) {
    if (price == null) return 0;
    const num = Number(String(price).replace(/[^\d.-]/g, ""));
    return Number.isFinite(num) ? num : 0;
  }

  function getLayersPriceSum() {
    const product = CPB.getStore().getState()?.Product;
    if (!product) return 0;

    const layers = product.layers ?? [];
    const categories = new Map();

    for (const panel of product.panels ?? []) {
      for (const category of panel.categories ?? []) {
        categories.set(String(category.id), category);
      }
    }

    const sourceQuantity = layers.reduce((qty, layer) => {
      const category = categories.get(String(layer.category));

      if (!categoryHasGroupSku(category)) {
        return qty;
      }

      return qty + 1;
    }, 0);

    return layers.reduce((total, layer) => {
      if (layer?.category === "base" || layer?.option === "base") {
        return total;
      }

      const category = categories.get(String(layer.category));

      if (!category) {
        return total + parseLayerPrice(layer?.price);
      }

      if (category.type === "calculateFields") {
        return total;
      }

      const option = (category.options ?? []).find(
        (item) => String(item.id) === String(layer.option)
      );

      if (categoryHasGroupSku(category)) {
        const skuPrice =
          option?.inventory?.price ??
          option?.optionPrice ??
          option?.price ??
          layer?.price;

        return total + parseLayerPrice(skuPrice);
      }

      if (categoryHasShuffGrips(category)) {
        const skuPrice =
          option?.inventory?.price ??
          option?.optionPrice ??
          option?.price ??
          layer?.price;

        return total + parseLayerPrice(skuPrice) * sourceQuantity;
      }

      return total + parseLayerPrice(layer?.price);
    }, 0);
  }

  function getPriceNode(el) {
    return (
      el.querySelector('[data-testid="multycurrency-price"]') ||
      el.querySelector(".cpb-product-price") ||
      el
    );
  }

  function formatLikePriceTemplate(amount, templateText) {
    const text = String(templateText).replace(/ /g, " ");
    const match = text.match(/\d[\d.,\s ]*\d|\d/);
    if (!match) return amount.toFixed(2);

    const numStr = match[0].replace(/\s/g, "");
    let decimalSep = ".";
    let thousandSep = ",";
    let decimals = 2;

    const sepIndex = Math.max(numStr.lastIndexOf(","), numStr.lastIndexOf("."));
    if (sepIndex !== -1) {
      const after = numStr.slice(sepIndex + 1);
      if (after.length >= 1 && after.length <= 2) {
        decimalSep = numStr[sepIndex];
        decimals = after.length;
        thousandSep = decimalSep === "," ? "." : ",";
      } else {
        thousandSep = numStr[sepIndex];
        decimalSep = thousandSep === "," ? "." : ",";
        decimals = 0;
      }
    }

    const fixed = Math.abs(amount).toFixed(decimals);
    const [intPart, fracPart] = fixed.split(".");
    const groupedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    let formatted = groupedInt;
    if (decimals > 0) formatted += decimalSep + fracPart;
    if (amount < 0) formatted = "-" + formatted;

    return text.replace(match[0], formatted);
  }

  function hasCustomPriceMetafield() {
    return categoryHasMetafield(
      CPB.getStore().getState()?.Product,
      "cpb-custom-price"
    );
  }

  function initLayersPriceSum() {
    if (!hasCustomPriceMetafield()) return;

    if (!document.getElementById("cpb-layers-price-sum-style")) {
      const style = document.createElement("style");
      style.id = "cpb-layers-price-sum-style";
      style.textContent =
        ".cpb-product-full-price:not(." +
        LAYERS_PRICE_SUM_CLASS +
        "){display:none !important;}";
      document.head.appendChild(style);
    }

    const render = () => {
      const originals = document.querySelectorAll(
        ".cpb-product-full-price:not(." + LAYERS_PRICE_SUM_CLASS + ")"
      );
      if (!originals.length) return;

      const sum = getLayersPriceSum();

      originals.forEach((original) => {
        let clone = original.nextElementSibling;
        if (!clone || !clone.classList.contains(LAYERS_PRICE_SUM_CLASS)) {
          clone = original.cloneNode(true);
          clone.classList.add(LAYERS_PRICE_SUM_CLASS);
          clone.removeAttribute("id");
          clone.removeAttribute("data-testid");
          original.after(clone);
        }

        const originalPriceNode = getPriceNode(original);
        const clonePriceNode = getPriceNode(clone);
        if (clonePriceNode) {
          clonePriceNode.textContent = formatLikePriceTemplate(
            sum,
            originalPriceNode ? originalPriceNode.textContent : String(sum)
          );
        }
      });
    };

    render();
    CPB.getStore().subscribe(render);
  }

  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", () => {
    CPB.FrontendApi().then((API) => (api = new API()));
    addToQuoteInit();
    customAddToCart();
    initLayersPriceSum();
  });
})(jQuery);
